<template>
  <div class="frame-complexes p-2">
    <b-breadcrumb>
      <b-breadcrumb-item to="/">Главная</b-breadcrumb-item>
      <b-breadcrumb-item active>Жилые комплексы</b-breadcrumb-item>
    </b-breadcrumb>

    <div class="card">
      <div class="card-body p-1">
        <b-form @submit.stop.prevent="onSubmit">
          <div class="col-sm-12 col-md-4 p-3">
            <div class="d-flex">
              <div class="form-group flex-fill mr-1">
                <div class="input-group">
                  <input type="text" v-model="name" class="form-control" placeholder="Поиск по наименованию">
                </div>
              </div>
              <div class="form-group">
                <div class="input-group">
                  <button type="submit" class="btn btn-success btn-icon">
                    <rb-icon class="icon-search"></rb-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </b-form>
        <b-table class="table table-striped projects" id="my-table" :fields="fields" :items="content">
          <template #cell(rownum)="data">
            {{ data.item.id }}
          </template>

          <template #cell(actions)="data">
            <router-link class="btn btn-info btn-icon btn-sm p-0" :to="'/complex/edit/' + data.item.id">
              <rb-icon icon="icon-edit" color="white" title="Редактировать"/>
            </router-link>
          </template>
        </b-table>

        <div class="pl-3">
          <b-pagination
              v-model="currentPage"
              aria-controls="my-table"
              :total-rows="rows"
              :per-page="perPage"
              @change="onPageChange"
              v-if="rows > perPage"
              first-number
              last-number
          ></b-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Frame from "@/components/Frame";
import {resComplexApi} from "../../api/resComplexApi";

export default {
  name: 'MortgageFrame',
  extends: Frame,
  data() {
    return {
      toolbar: {
        title: 'Жилые комплексы',
        icon: 'icon-building',
        actions: []
      },
      currentPage: 1,
      perPage: 10,
      name: "",
      items: [],
      content: [],
      fields: [
        {key: 'rownum', label: '#'},
        {key: 'name', label: 'Наименование'},
        {key: 'nameEn', label: 'Наименование en'},
        {key: 'nameKk', label: 'Наименование kk'},
        {key: 'actions', label: 'Действия', class: 'v-column-actions'}
      ]
    }
  },

  methods: {
    onSubmit() {
      if (this.name !== null) {
        resComplexApi.list(this.currentPage, this.name).then(response => {
          this.items = response.data;
          this.content = this.items.content;
        });
      }
    },
    onPageChange(page) {
      resComplexApi.list(page, this.name).then(response => {
        this.items = response.data;
        this.content = this.items.content;
      });
    }
  },

  mounted() {
    resComplexApi.list(this.currentPage, this.name).then(response => {
      this.items = response.data;
      this.content = this.items.content;
    });
  },

  computed: {
    rows() {
      return this.items.totalElements;
    }
  }
}
</script>
